import { useCallback, useMemo } from 'react';

import { useIntegrationsPage } from 'pages/Settings/integrations/hooks/useIntegrationsPage';

export const useIntegrationsForm = ({ network, linkedinSyncBasePath, linkedinSyncReturnTo, onGoogleSyncComplete }) => {
  const {
    googleSync,
    googleLogin,
    linkedinSync,
    hasGoogleSyncFeature,
    hasRelationshipStrength,
    googleConnectModalOpen,
    initialConnectPreferences,
    openGoogleConnectModal,
    closeGoogleConnectModal,
    submitGooglePreferences,
    isCreatingGoogleAccount,
    isLaunchingGoogleOAuth,
    isUpdatingGoogleAccount,
  } = useIntegrationsPage({
    network,
    onGoogleSyncComplete,
  });

  const isLinkedinConnected = !!linkedinSync?.syncStatus && linkedinSync.syncStatus !== 'not_connected';
  const isGoogleConnected = !!googleSync?.syncStatus && googleSync.syncStatus !== 'not_connected';

  const allIntegrationsDone = useMemo(
    () => isLinkedinConnected && (!hasGoogleSyncFeature || isGoogleConnected),
    [isLinkedinConnected, hasGoogleSyncFeature, isGoogleConnected],
  );

  const anyIntegrationDone = useMemo(
    () => isLinkedinConnected || (hasGoogleSyncFeature && isGoogleConnected),
    [isLinkedinConnected, hasGoogleSyncFeature, isGoogleConnected],
  );

  const getLinkedinSyncLink = useCallback(
    (status = 'sync') => {
      const baseUrl = `${linkedinSyncBasePath}/${status}`;
      return linkedinSyncReturnTo ? `${baseUrl}?returnTo=${linkedinSyncReturnTo}` : baseUrl;
    },
    [linkedinSyncBasePath, linkedinSyncReturnTo],
  );

  return {
    googleSync,
    googleLogin,
    linkedinSync,
    hasGoogleSyncFeature,
    hasRelationshipStrength,
    googleConnectModalOpen,
    initialConnectPreferences,
    openGoogleConnectModal,
    closeGoogleConnectModal,
    submitGooglePreferences,
    isCreatingGoogleAccount,
    isLaunchingGoogleOAuth,
    isUpdatingGoogleAccount,
    allIntegrationsDone,
    anyIntegrationDone,
    getLinkedinSyncLink,
  };
};
